// Sticky-settings keys for the New Game form. Owned here (not in
// the page) so other surfaces — Game Detail's "Play Again" button,
// the virtual endgame card, etc. — can seed the form for a rematch
// without each one redefining the same string keys.
//
// Schema:
//   newgame.format      "singles" | "doubles"
//   newgame.team1Ids    player id[]
//   newgame.team2Ids    player id[]
//   newgame.targetScore number
//
// Date is intentionally NOT sticky.

export const NEW_GAME_KEYS = {
  format: "newgame.format",
  team1: "newgame.team1Ids",
  team2: "newgame.team2Ids",
  target: "newgame.targetScore",
  scoringMethod: "newgame.scoringMethod",
} as const;

export type RematchSeed = {
  format: "singles" | "doubles";
  team1Players: { id: string }[];
  team2Players: { id: string }[];
  targetScore: number;
};

// Write a completed game's config into the sticky-state keys so the
// next visit to /dashboard/games/new opens prefilled for a rematch.
// Errors (quota / private mode) are swallowed — the form will just
// fall back to its existing sticky / default values.
export function seedNewGameForRematch(game: RematchSeed): void {
  if (typeof window === "undefined") return;
  try {
    const ls = window.localStorage;
    ls.setItem(NEW_GAME_KEYS.format, JSON.stringify(game.format));
    ls.setItem(
      NEW_GAME_KEYS.team1,
      JSON.stringify(game.team1Players.map((p) => p.id)),
    );
    ls.setItem(
      NEW_GAME_KEYS.team2,
      JSON.stringify(game.team2Players.map((p) => p.id)),
    );
    ls.setItem(NEW_GAME_KEYS.target, JSON.stringify(game.targetScore));
  } catch {
    // ignore quota / disabled-storage errors
  }
}
